import groupBy from 'lodash/groupBy';
import isEqual from 'lodash/isEqual';
import actionTypes from './action-types';
import * as api from '../resources/contact.api';

export const fetchLotteryContactsRequest = () => ({
  type: actionTypes.FETCH_LOTTERY_CONTACTS_REQUEST,
  name: 'lotteryLoadingStatus',
});

export const fetchLotteryContactsFailure = () => ({
  type: actionTypes.FETCH_LOTTERY_CONTACTS_FAILURE,
  name: 'lotteryLoadingStatus',
});

export const fetchLotteryContactsSuccess = (contact) => ({
  type: actionTypes.FETCH_LOTTERY_CONTACTS_SUCCESS,
  contact,
  name: 'lotteryLoadingStatus',
});

export const fetchLotteryContacts =
  (home = false) =>
  async (dispatch, getState) => {
    try {
      const { config } = getState();
      const { jurisdictionId, secondHandApproval } = config;
      const params = {
        home,
        jurisdictionId,
        secondHandApproval,
      };

      dispatch(fetchLotteryContactsRequest());
      const contact = await api.fetchLotteryContacts(params);
      dispatch(fetchLotteryContactsSuccess(contact));
    } catch (error) {
      dispatch(fetchLotteryContactsFailure());
      // eslint-disable-next-line no-console
      console.error('FETCH_LOTTERY_CONTACTS', error);
    }
  };

export const discardLotteryContactsChangesRequest = () => ({
  type: actionTypes.DISCARD_LOTTERY_CONTACTS_CHANGES_REQUEST,
});

export const discardLotteryContactsChangesFailure = () => ({
  type: actionTypes.DISCARD_LOTTERY_CONTACTS_CHANGES_FAILURE,
});

export const discardLotteryContactsChangesSuccess = () => ({
  type: actionTypes.DISCARD_LOTTERY_CONTACTS_CHANGES_SUCCESS,
});

export const discardLotteryContactsChanges = () => async (dispatch, getState) => {
  try {
    const { config } = getState();
    const { jurisdictionId } = config;

    dispatch(discardLotteryContactsChangesRequest());
    await api.discardLotteryContactsChanges(jurisdictionId);
    dispatch(discardLotteryContactsChangesSuccess());
  } catch (error) {
    dispatch(discardLotteryContactsChangesFailure());
    // eslint-disable-next-line no-console
    console.error('DISCARD_LOTTERY_CONTACTS_CHANGES', error);
  }
};

export const publishLotteryContactsChangesRequest = () => ({
  type: actionTypes.PUBLISH_LOTTERY_CONTACTS_CHANGES_REQUEST,
});

export const publishLotteryContactsChangesFailure = () => ({
  type: actionTypes.PUBLISH_LOTTERY_CONTACTS_CHANGES_FAILURE,
});

export const publishLotteryContactsChangesSuccess = () => ({
  type: actionTypes.PUBLISH_LOTTERY_CONTACTS_CHANGES_SUCCESS,
});

export const publishLotteryContactsChanges = () => async (dispatch, getState) => {
  try {
    const { config, contact } = getState();
    const { jurisdictionId, secondHandApproval } = config;
    const {
      lottery: { contactList },
    } = contact;

    const params = {
      jurisdictionId,
      secondHandApproval,
      contactList,
    };

    dispatch(publishLotteryContactsChangesRequest());
    await api.publishLotteryContactsChanges(params);
    dispatch(publishLotteryContactsChangesSuccess());
  } catch (error) {
    dispatch(publishLotteryContactsChangesFailure());
    // eslint-disable-next-line no-console
    console.error('PUBLISH_LOTTERY_CONTACTS_CHANGES', error);
  }
};

export const fetchInquiryContactsRequest = () => ({
  type: actionTypes.FETCH_INQUIRY_CONTACTS_REQUEST,
  name: 'inquiryLoadingStatus',
});

export const fetchInquiryContactsFailure = () => ({
  type: actionTypes.FETCH_INQUIRY_CONTACTS_FAILURE,
  name: 'inquiryLoadingStatus',
});

export const fetchInquiryContactsSuccess = (items) => ({
  type: actionTypes.FETCH_INQUIRY_CONTACTS_SUCCESS,
  items,
  name: 'inquiryLoadingStatus',
});

export const fetchInquiryContacts = (parameters) => async (dispatch) => {
  try {
    dispatch(fetchInquiryContactsRequest());
    const queryParams = {
      ...parameters,
      pageNumber: 0,
      pageSize: 0,
    };
    const response = await api.fetchInquiryContacts(queryParams);
    const items = groupBy(response, 'locale');
    dispatch(fetchInquiryContactsSuccess(items));
  } catch (error) {
    dispatch(fetchInquiryContactsFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_LOTTERY_CONTACTS', error);
  }
};

export const updateInquiryContact = () => (dispatch, getState) => {
  const { contact, config } = getState();
  const { locales } = config;
  const {
    inquiry: { items, itemsCopy },
  } = contact;
  const requests = [];

  locales.forEach((locale) => {
    items[locale.code] = items[locale.code] || [];
    // eslint-disable-next-line array-callback-return
    items[locale.code].map((inquiryContact, index) => {
      if (!isEqual(inquiryContact, itemsCopy[locale.code][index])) {
        const params = {};
        const { contactEmail, availableForUser, availableForAnonymous } = inquiryContact;
        params[locale.code] = { contactEmail, availableForUser, availableForAnonymous };
        requests.push(api.updateInquiryContact(params, inquiryContact));
      }
    });
  });

  return Promise.all(requests);
};



// WEBPACK FOOTER //
// ./src/modules/contact/actions/contact.actions.js